var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4f46e5",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 229",
    xmlSpace: "preserve",
    stroke: "#4f46e5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193,147.9h-37.8v-39.4c0-17.4-14.1-31.5-31.5-31.5H33.5C16.1,77,2,91.1,2,108.5l0,104.4c0,7.6,6.2,13.8,13.8,13.8 c3.8,0,7.3-1.5,9.8-4c2.5-2.5,4-5.9,4-9.8v-88.7c0-2.1,1.7-3.9,3.9-3.9h0.1c2.2,0,3.9,1.7,3.9,3.9v102.5h82.7V124.5 c0-2.3,1.5-4.2,4.2-4.2c2.5,0.1,3.7,2.2,3.7,4.3l0,35c0,8.7,7.1,15.8,15.8,15.7l49.1,0.1c7.6,0,13.8-6.2,13.8-13.8l0,0 C206.8,154,200.6,147.9,193,147.9z M50.4,20.5c8.6-13.6,18.4-19,32.1-18c18.4,1.3,32.3,17.4,31,35.8c-1.3,18.4-17.3,31.3-35.8,31 C54,68.8,35.3,53.2,28,38.7l0,0C38,36.8,45,29.1,50.4,20.5z M247,90.6c-7.3-11.9-22.8-32.1-30.5-42l20.3-29.9h-56.2l20.2,29.8 c-7.7,9.8-23.3,30.1-30.6,42.1c-3.3,5.4-7,11.5-7,21.4c0,15.4,11.7,28,26.1,28h38.5c14.4,0,26.1-12.6,26.1-28 C254,102.1,250.3,96,247,90.6z M211.8,116.9v5.4h-6.7v-5.6c-3.5-0.8-6.8-2.5-9.8-5.3l5.1-5.6c0,0,3.7,3.2,7.2,3.7 c4,0.6,6.4-1.3,6.7-3.8c0.5-4.7-8.7-6.5-12-8.3c-4-2.1-7.9-5-7.9-11.1c0-6.2,4.3-10.8,10.8-11.4v-5.8h6.7v6c4.2,0.9,7.1,3.2,9.4,4.9 l-4.6,6c-1.4-1.3-4.1-3-6.6-3.6c-3.2-0.8-6.7,0.1-6.9,3.6c-0.1,1.4,0.5,4.3,7.5,6.4c3.7,1.2,12.3,3.7,12.3,12.7 C222.9,111.3,218.2,116.2,211.8,116.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestor);
export default __webpack_public_path__ + "static/media/investor.597dc0d5ba66c787055c516259e9441b.svg";
export { ForwardRef as ReactComponent };